import { render, staticRenderFns } from "./EmailVerification.vue?vue&type=template&id=7030e366&scoped=true"
import script from "./EmailVerification.vue?vue&type=script&lang=js"
export * from "./EmailVerification.vue?vue&type=script&lang=js"
import style0 from "./EmailVerification.vue?vue&type=style&index=0&id=7030e366&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7030e366",
  null
  
)

export default component.exports